import React from "react";

const DefaultPage: React.FC = () => {
  const divStyle = {
    height: "200px",
  };

  return <div style={divStyle}></div>;
};

export default DefaultPage;
